/* =====================================================================
   FAQ Chat Widget — an FAQ picker styled as a live-chat window.
   No backend, no per-visitor cost. Everything runs in the browser.

   HOW TO EDIT: everything a store owner should touch lives in the
   CONFIG block directly below — colors, greeting, FAQs, fallback.
   ===================================================================== */

(function () {
  "use strict";

  /* ================== CONFIG — edit this block only ================== */
  var CONFIG = window.FAQChatConfig || {
    storeName: "Camp Social",
    accentColor: "#135416",          // Camp Social's sign-up-button green
    launcherLabel: "Questions? We can help",
    greeting: "Hey camper! 👋 I can answer common questions instantly. Pick a topic below, or type your question.",
    inputPlaceholder: "Type a question…",
    // Where people go when the bot can't answer:
    fallbackEmail: "hello@campsocial.com",
    contactPageUrl: "",
    faqPageUrl: "/pages/faqs",
    // Categories are optional — FAQs without a category show under "Popular".
    faqs: [
      {
        category: "About Camp",
        q: "What is Camp Social?",
        keywords: ["what", "about", "camp", "social", "explain", "sleepaway"],
        a: "Camp Social is a women's-only sleepaway camp weekend that brings over 300 women from around the world together to connect IRL. 99% arrive solo, and 100% leave as friends. It's part nostalgia, part utopia and complete magic — expect the best weekend of your adult life, filled with laughter, friendship, and maybe a few happy tears."
      },
      {
        category: "About Camp",
        q: "Who is Camp Social for?",
        keywords: ["who", "for", "women", "only", "single", "married", "men"],
        a: "It's for anyone craving connection. Whether you're 22 or 104 (our oldest camper has been 86), single or married, shy or social-butterfly-in-recovery — Camp Social was built for women who want to meet new friends in a real, fun, feel-like-a-kid-again space. All you have to do is show up with a smile and a willingness to meet new friends."
      },
      {
        category: "About Camp",
        q: "Can I actually come solo?",
        keywords: ["solo", "alone", "myself", "friend", "know", "nobody", "single"],
        a: "Absolutely. 99% of campers arrive solo and 100% leave as friends — plus a new group chat that lasts all year. Camp Social is literally designed to make meeting girlfriends of all ages easy (and fun). Come with an open mind and a young-at-heart attitude, and we take care of the rest."
      },
      {
        category: "About Camp",
        q: "Do people of all ages actually come?",
        keywords: ["age", "ages", "old", "older", "young", "limit", "50", "60", "70"],
        a: "YES! There is no age limit on fun. Our eldest camper has been 86, and over half of camp is over 55, with bunks of women in their 60s, 70s, and 80s. You'll be bunked by age in general housing, or you can choose a private room. Camp does require a lot of walking, so please keep that in mind. We're activity-based, so you make friends at every turn, activity, and meal."
      },
      {
        category: "About Camp",
        q: "I have social anxiety — will I feel comfortable?",
        keywords: ["anxiety", "anxious", "nervous", "shy", "scared", "introvert", "comfortable", "awkward"],
        a: "Yes. Our camp culture is built on kindness and inclusivity. We know how nerve-wracking it can be to show up alone, which is why our staff and counselors are trained to make every moment feel welcoming. You'll never sit alone at meals, and you'll always have a built-in crew to join. Within hours of arrival, you'll forget you ever worried."
      },
      {
        category: "Tickets & Pricing",
        q: "When is Camp Social 2027? Is it sold out?",
        keywords: ["when", "date", "dates", "2027", "2028", "tickets", "sale", "sold", "out", "waitlist", "next", "june", "august", "september", "weekend", "weekends"],
        a: "Camp Social 2027 sold out in less than a day! You can get on the waitlist for Camp Social 2028 at campsocial.com. And stay tuned for future retreats and pop-up camps — our new retreat, Bunk One, takes place in February and April of 2027 in San Diego."
      },
      {
        category: "Tickets & Pricing",
        q: "What is Bunk One?",
        keywords: ["bunk", "one", "san", "diego", "california", "west", "coast", "february", "april", "retreat", "new"],
        a: "Bunk One is the brand-new retreat experience from Camp Social, taking place in San Diego in February and April of 2027. The Bunk One 2027 waitlist is open now at campsocial.com!"
      },
      {
        category: "Tickets & Pricing",
        q: "How much does Camp Social cost?",
        keywords: ["cost", "price", "much", "expensive", "money", "fee"],
        a: "Camp Social costs around $1,129, and it's all-inclusive — lodging, all meals, snacks, drinks, and activities. We also offer options to pay in installments with Klarna."
      },
      {
        category: "Tickets & Pricing",
        q: "Do you offer payment plans?",
        keywords: ["payment", "plan", "installments", "klarna", "afford", "split"],
        a: "Yes! Payment plans are available at checkout for anyone who'd like to take advantage of that option — including installments through Klarna."
      },
      {
        category: "Tickets & Pricing",
        q: "How do I sign up?",
        keywords: ["sign", "register", "waitlist", "join", "book", "spot", "reserve"],
        a: "Visit campsocial.com to join the waitlist or grab your spot for our next session. Spaces sell out fast — and so does the merch!"
      },
      {
        category: "Tickets & Pricing",
        q: "If I cancel, do I get a refund?",
        keywords: ["refund", "cancel", "cancellation", "transfer", "policy", "change"],
        a: "No — because this experience is so personalized, we do not accept any refunds or cancellations for any matter."
      },
      {
        category: "Getting There & Hotels",
        q: "Where is Camp Social?",
        keywords: ["where", "location", "located", "pennsylvania", "equinunk", "far"],
        a: "Equinunk, Pennsylvania — a lakeside property with stunning views, cozy cabins, and all the nostalgic touches of summer camp. It's about 2.5 hours from New York City."
      },
      {
        category: "Getting There & Hotels",
        q: "How do I get to camp?",
        keywords: ["get", "there", "bus", "drive", "driving", "parking", "transportation", "travel"],
        a: "Two easy options: 1) Take the official round-trip Camp Social bus from Manhattan — it's the easiest, most social option, and where the friendships start (reserve your spot through camp ticketing). 2) Drive yourself — camp is 2.5 hours from NYC with free on-site parking. A detailed arrival guide is sent to everyone before camp."
      },
      {
        category: "Getting There & Hotels",
        q: "I'm flying in — which airport, and where do I stay?",
        keywords: ["fly", "flying", "flight", "airport", "ewr", "jfk", "newark", "hotel", "stay", "before", "night"],
        a: "Fly into EWR (Newark) or JFK (New York) — both offer easy Uber, Lyft, or cab rides into Manhattan. Then stay at one of our official Camp Social hotel partners, like the Frederick Hotel (code CAMPSOCIAL), where tons of other campers stay the night before — the friend-making starts pre-camp! Then hop on the Camp Social bus the next morning. Hotel booking links and cutoff dates are on our FAQ page."
      },
      {
        category: "Food & Meals",
        q: "Are meals included?",
        keywords: ["meals", "food", "included", "eat", "drinks", "alcohol", "cocktails", "snacks"],
        a: "Yes! All meals, snacks, and drinks are included in your all-inclusive ticket — everything from morning coffee to late-night snacks. Expect chef-prepared meals, fireside s'mores, and cocktails (or mocktails)."
      },
      {
        category: "Food & Meals",
        q: "What if I have allergies or dietary restrictions?",
        keywords: ["allergies", "allergy", "dietary", "vegan", "vegetarian", "gluten", "dairy", "nut", "restrictions"],
        a: "We offer a wide selection to accommodate all dietary preferences — vegetarian, vegan, gluten-free, dairy-free, and more. Add your restrictions when you register and our special dietary chef will have your name and needs ready to go. We're also a nut-free facility!"
      },
      {
        category: "Camp Life",
        q: "How does rooming work?",
        keywords: ["rooming", "room", "bunk", "bunks", "sleep", "cabin", "roommates", "private"],
        a: "We bunk by age, so you'll share a bunk with 8–10 women your age from around the world. Every bunk has showers and bathrooms inside, shampoo/conditioner/body wash, linens, and outlets. Very little time is spent in bunks — every activity is your choice, and we're out and about all day and night. Prefer quiet at night? A limited number of private rooms are available."
      },
      {
        category: "Camp Life",
        q: "What should I pack?",
        keywords: ["pack", "packing", "bring", "list", "clothes", "wear"],
        a: "An initial recommended packing list is sent in your confirmation email when you register, and a more detailed list is sent out closer to the event."
      }
    ]
  };
  /* ================ END CONFIG — no edits needed below =============== */

  var TYPING_MS = 700; // fake "typing…" delay so answers feel conversational

  /* ---------- tiny helpers ---------- */
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function esc(s) {
    var d = document.createElement("div");
    d.textContent = s;
    return d.innerHTML;
  }

  /* ---------- search: score FAQs against typed text ---------- */
  var STOP = { the: 1, a: 1, an: 1, is: 1, are: 1, do: 1, does: 1, can: 1, i: 1, my: 1, you: 1, your: 1, to: 1, of: 1, in: 1, on: 1, for: 1, it: 1, how: 1, what: 1, we: 1 };
  function tokens(s) {
    return s.toLowerCase().replace(/[^a-z0-9\s]/g, " ").split(/\s+/).filter(function (w) {
      return w.length > 1 && !STOP[w];
    });
  }
  function scoreFaq(faq, queryTokens) {
    var hay = tokens(faq.q).concat((faq.keywords || []).map(function (k) { return k.toLowerCase(); }));
    var score = 0;
    queryTokens.forEach(function (qt) {
      hay.forEach(function (h) {
        if (h === qt) score += 3;
        else if (h.indexOf(qt) === 0 || qt.indexOf(h) === 0) score += 1;
      });
    });
    return score;
  }
  function searchFaqs(query, limit) {
    var qt = tokens(query);
    if (!qt.length) return [];
    return CONFIG.faqs
      .map(function (f) { return { faq: f, score: scoreFaq(f, qt) }; })
      .filter(function (r) { return r.score > 0; })
      .sort(function (a, b) { return b.score - a.score; })
      .slice(0, limit || 3);
  }

  /* ---------- styles ---------- */
  var ACCENT = CONFIG.accentColor || "#1a73e8";
  var css = "\
  .fcw-launcher{position:fixed;bottom:20px;right:20px;z-index:2147483000;display:flex;align-items:center;gap:10px;border:none;cursor:pointer;background:" + ACCENT + ";color:#fff;border-radius:999px;padding:14px 18px;font:600 15px/1 -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;box-shadow:0 6px 24px rgba(0,0,0,.22);transition:transform .15s ease}\
  .fcw-launcher:hover{transform:translateY(-2px)}\
  .fcw-launcher svg{width:20px;height:20px;flex:none}\
  .fcw-launcher .fcw-label{white-space:nowrap}\
  @media(max-width:480px){.fcw-launcher .fcw-label{display:none}.fcw-launcher{padding:14px}}\
  .fcw-panel{position:fixed;bottom:90px;right:20px;z-index:2147483000;width:370px;max-width:calc(100vw - 24px);height:560px;max-height:calc(100vh - 110px);display:flex;flex-direction:column;background:#fff;border-radius:16px;box-shadow:0 12px 48px rgba(0,0,0,.25);overflow:hidden;font-family:-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;opacity:0;transform:translateY(12px);pointer-events:none;transition:opacity .18s ease,transform .18s ease}\
  .fcw-panel.fcw-open{opacity:1;transform:translateY(0);pointer-events:auto}\
  @media(max-width:480px){.fcw-panel{right:12px;bottom:84px}}\
  .fcw-header{background:" + ACCENT + ";color:#fff;padding:16px;display:flex;align-items:center;gap:12px;flex:none}\
  .fcw-avatar{width:38px;height:38px;border-radius:50%;background:rgba(255,255,255,.25);display:flex;align-items:center;justify-content:center;flex:none}\
  .fcw-avatar svg{width:20px;height:20px}\
  .fcw-htext{flex:1;min-width:0}\
  .fcw-hname{font-weight:700;font-size:15px}\
  .fcw-hsub{font-size:12px;opacity:.85;display:flex;align-items:center;gap:5px;margin-top:2px}\
  .fcw-dot{width:7px;height:7px;border-radius:50%;background:#5cf28e;flex:none}\
  .fcw-close{border:none;background:transparent;color:#fff;cursor:pointer;padding:6px;border-radius:8px;line-height:0}\
  .fcw-close:hover{background:rgba(255,255,255,.15)}\
  .fcw-close svg{width:18px;height:18px}\
  .fcw-body{flex:1;overflow-y:auto;padding:16px;background:#f6f7f9;display:flex;flex-direction:column;gap:10px}\
  .fcw-msg{max-width:85%;padding:10px 14px;border-radius:16px;font-size:14px;line-height:1.45;white-space:pre-line;overflow-wrap:break-word}\
  .fcw-bot{background:#fff;color:#1f2430;border-bottom-left-radius:4px;align-self:flex-start;box-shadow:0 1px 2px rgba(0,0,0,.07)}\
  .fcw-user{background:" + ACCENT + ";color:#fff;border-bottom-right-radius:4px;align-self:flex-end}\
  .fcw-msg a{color:" + ACCENT + ";font-weight:600;text-decoration:underline}\
  .fcw-user a{color:#fff}\
  .fcw-chips{display:flex;flex-wrap:wrap;gap:8px;align-self:flex-start;max-width:95%}\
  .fcw-chip{border:1.5px solid " + ACCENT + ";color:" + ACCENT + ";background:#fff;border-radius:999px;padding:8px 14px;font-size:13px;font-weight:600;cursor:pointer;font-family:inherit;text-align:left;transition:background .12s ease,color .12s ease}\
  .fcw-chip:hover{background:" + ACCENT + ";color:#fff}\
  .fcw-typing{display:inline-flex;gap:5px;padding:14px 16px;background:#fff;border-radius:16px;border-bottom-left-radius:4px;align-self:flex-start;box-shadow:0 1px 2px rgba(0,0,0,.07)}\
  .fcw-typing span{width:7px;height:7px;border-radius:50%;background:#b6bcc8;animation:fcwBlink 1.2s infinite}\
  .fcw-typing span:nth-child(2){animation-delay:.2s}\
  .fcw-typing span:nth-child(3){animation-delay:.4s}\
  @keyframes fcwBlink{0%,80%,100%{opacity:.3}40%{opacity:1}}\
  .fcw-inputrow{display:flex;gap:8px;padding:12px;background:#fff;border-top:1px solid #e7e9ee;flex:none}\
  .fcw-input{flex:1;border:1.5px solid #dfe3ea;border-radius:999px;padding:10px 16px;font-size:14px;font-family:inherit;outline:none;color:#1f2430;background:#fff}\
  .fcw-input:focus{border-color:" + ACCENT + "}\
  .fcw-send{border:none;background:" + ACCENT + ";color:#fff;width:40px;height:40px;border-radius:50%;cursor:pointer;flex:none;display:flex;align-items:center;justify-content:center}\
  .fcw-send svg{width:18px;height:18px}\
  .fcw-send:disabled{opacity:.4;cursor:default}\
  ";

  var ICONS = {
    chat: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"/></svg>',
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>',
    send: '<svg viewBox="0 0 24 24" fill="currentColor"><path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"/></svg>'
  };

  /* ---------- build DOM ---------- */
  function build() {
    var style = document.createElement("style");
    style.textContent = css;
    document.head.appendChild(style);

    var launcher = el("button", "fcw-launcher");
    launcher.type = "button";
    launcher.setAttribute("aria-label", "Open help chat");
    launcher.innerHTML = ICONS.chat + '<span class="fcw-label">' + esc(CONFIG.launcherLabel) + "</span>";

    var panel = el("div", "fcw-panel");
    panel.setAttribute("role", "dialog");
    panel.setAttribute("aria-label", CONFIG.storeName + " help");

    var header = el("div", "fcw-header");
    var avatar = el("div", "fcw-avatar");
    avatar.innerHTML = ICONS.chat;
    var htext = el("div", "fcw-htext");
    htext.appendChild(el("div", "fcw-hname", CONFIG.storeName));
    var hsub = el("div", "fcw-hsub");
    hsub.appendChild(el("span", "fcw-dot"));
    hsub.appendChild(document.createTextNode("Instant answers"));
    htext.appendChild(hsub);
    var closeBtn = el("button", "fcw-close");
    closeBtn.type = "button";
    closeBtn.setAttribute("aria-label", "Close chat");
    closeBtn.innerHTML = ICONS.close;
    header.appendChild(avatar);
    header.appendChild(htext);
    header.appendChild(closeBtn);

    var body = el("div", "fcw-body");

    var inputRow = el("form", "fcw-inputrow");
    var input = el("input", "fcw-input");
    input.type = "text";
    input.placeholder = CONFIG.inputPlaceholder;
    input.setAttribute("aria-label", "Type your question");
    var sendBtn = el("button", "fcw-send");
    sendBtn.type = "submit";
    sendBtn.setAttribute("aria-label", "Send");
    sendBtn.innerHTML = ICONS.send;
    inputRow.appendChild(input);
    inputRow.appendChild(sendBtn);

    panel.appendChild(header);
    panel.appendChild(body);
    panel.appendChild(inputRow);

    document.body.appendChild(launcher);
    document.body.appendChild(panel);

    /* ---------- chat mechanics ---------- */
    function scrollDown() { body.scrollTop = body.scrollHeight; }

    function addBot(html) {
      var m = el("div", "fcw-msg fcw-bot");
      m.innerHTML = html;
      body.appendChild(m);
      scrollDown();
      return m;
    }
    function addUser(text) {
      body.appendChild(el("div", "fcw-msg fcw-user", text));
      scrollDown();
    }
    function withTyping(fn) {
      var t = el("div", "fcw-typing");
      t.innerHTML = "<span></span><span></span><span></span>";
      body.appendChild(t);
      scrollDown();
      setTimeout(function () {
        t.remove();
        fn();
      }, TYPING_MS);
    }
    function addChips(items) {
      var wrap = el("div", "fcw-chips");
      items.forEach(function (it) {
        var c = el("button", "fcw-chip", it.label);
        c.type = "button";
        c.addEventListener("click", function () { it.onClick(wrap); });
        wrap.appendChild(c);
      });
      body.appendChild(wrap);
      scrollDown();
      return wrap;
    }

    function categories() {
      var seen = {}, out = [];
      CONFIG.faqs.forEach(function (f) {
        var c = f.category || "Popular";
        if (!seen[c]) { seen[c] = true; out.push(c); }
      });
      return out;
    }

    function fallbackHtml() {
      var parts = [];
      if (CONFIG.contactPageUrl) parts.push('<a href="' + esc(CONFIG.contactPageUrl) + '">send us a message</a>');
      if (CONFIG.fallbackEmail) parts.push('email <a href="mailto:' + esc(CONFIG.fallbackEmail) + '">' + esc(CONFIG.fallbackEmail) + "</a>");
      // No contact options configured → deflect-only mode: point to the FAQ
      // page and topic chips, never invite an email.
      if (!parts.length) {
        return "Hmm, I don't have an answer for that one." +
          (CONFIG.faqPageUrl ? ' Our full <a href="' + esc(CONFIG.faqPageUrl) + '">FAQ page</a> might cover it — or try one of the topics below.' : " Try one of the topics below.");
      }
      return "Hmm, I don't have an answer for that one. You can " + parts.join(" or ") + " and a real human will get back to you." +
        (CONFIG.faqPageUrl ? ' You can also browse our full <a href="' + esc(CONFIG.faqPageUrl) + '">FAQ page</a>.' : "");
    }

    function showCategoryMenu(intro) {
      if (intro) addBot(intro);
      addChips(categories().map(function (cat) {
        return {
          label: cat,
          onClick: function (chipWrap) {
            chipWrap.remove();
            addUser(cat);
            withTyping(function () { showQuestions(cat); });
          }
        };
      }));
    }

    function showQuestions(cat) {
      addBot("Here's what people usually ask about <b>" + esc(cat) + "</b>:");
      var faqs = CONFIG.faqs.filter(function (f) { return (f.category || "Popular") === cat; });
      var items = faqs.map(function (f) {
        return {
          label: f.q,
          onClick: function (chipWrap) {
            chipWrap.remove();
            answer(f);
          }
        };
      });
      items.push({
        label: "← Back to topics",
        onClick: function (chipWrap) {
          chipWrap.remove();
          showCategoryMenu();
        }
      });
      addChips(items);
    }

    function answer(faq) {
      addUser(faq.q);
      withTyping(function () {
        addBot(esc(faq.a));
        setTimeout(function () {
          addBot("Anything else I can help with?");
          showCategoryMenu();
        }, 400);
      });
    }

    function handleQuery(text) {
      addUser(text);
      withTyping(function () {
        var results = searchFaqs(text, 3);
        if (!results.length) {
          addBot(fallbackHtml());
          showCategoryMenu("Or pick a topic:");
          return;
        }
        // Answer directly only on a confident match (2+ strong keyword hits and
        // a clear lead over the runner-up). A single weak hit — e.g. "bring" in
        // "can I bring my dog" — gets suggested, not answered, so the bot never
        // gives a confident wrong answer.
        var top = results[0];
        var second = results[1];
        var confident = top.score >= 6 && (!second || top.score >= second.score * 2);
        if (results.length === 1 && confident) {
          addBot(esc(top.faq.a));
          setTimeout(function () {
            addBot("Anything else I can help with?");
            showCategoryMenu();
          }, 400);
          return;
        }
        var matches = results.map(function (r) { return r.faq; });
        addBot(matches.length === 1
          ? "I might have an answer for that — is this what you're looking for?"
          : "I found a few answers that might help — which one is closest?");
        var items = matches.map(function (f) {
          return {
            label: f.q,
            onClick: function (chipWrap) {
              chipWrap.remove();
              answer(f);
            }
          };
        });
        items.push({
          label: "None of these",
          onClick: function (chipWrap) {
            chipWrap.remove();
            addBot(fallbackHtml());
            showCategoryMenu("Or pick a topic:");
          }
        });
        addChips(items);
      });
    }

    /* ---------- open/close ---------- */
    var opened = false;
    function openPanel() {
      panel.classList.add("fcw-open");
      launcher.setAttribute("aria-expanded", "true");
      if (!opened) {
        opened = true;
        withTyping(function () {
          addBot(esc(CONFIG.greeting));
          showCategoryMenu();
        });
      }
      input.focus();
    }
    function closePanel() {
      panel.classList.remove("fcw-open");
      launcher.setAttribute("aria-expanded", "false");
    }
    launcher.addEventListener("click", function () {
      panel.classList.contains("fcw-open") ? closePanel() : openPanel();
    });
    closeBtn.addEventListener("click", closePanel);
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closePanel();
    });

    /* ---------- input ---------- */
    function submit() {
      var v = input.value.trim();
      if (!v) return;
      input.value = "";
      handleQuery(v);
    }
    inputRow.addEventListener("submit", function (e) {
      e.preventDefault();
      submit();
    });
    input.addEventListener("keydown", function (e) {
      if (e.key === "Enter") { e.preventDefault(); submit(); }
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", build);
  } else {
    build();
  }
})();
